<!--
  导出excel
  lovi 2020-06-11
-->
<template>
  <div>
    <Button type="primary" @click="exportExcel" v-if="btnType">
      {{ btnText }}
    </Button>
    <a
      href="javascript:void(0)"
      class="text-blue"
      v-else
      @click="exportExcel"
      >{{ btnText }}</a
    >
  </div>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  props: {
    btnType: {
      // 按钮类型 button text
      type: Number,
      default: 0
    },
    btnText: {
      // 按钮文字
      type: String,
      default: ""
    },
    fileName: {
      //文件名
      type: String,
      default: "example"
    },
    tHeader: {
      type: Array,
      default: function() {
        return [];
      }
    },
    filterVal: {
      type: Array,
      default: function() {
        return [];
      }
    },
    exportList: {
      //导出数据
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    exportExcel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/vendor/Export2Excel");
        export_json_to_excel(
          this.tHeader,
          this.formatJson(this.filterVal, this.exportList),
          this.fileName
        );
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    exportExcel1() {
      const defaultCellStyle = {
        font: { name: "Verdana", sz: 11, color: "FF00FF88" },
        fill: { fgColor: { rgb: "FFFFAA00" } }
      };
      const wopts = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
        defaultCellStyle: defaultCellStyle,
        showGridLines: false
      };
      const wb = { SheetNames: ["Sheet1"], Sheets: {}, Props: {} };
      let data = this.exportList;
      wb.Sheets["Sheet1"] = XLSX.utils.json_to_sheet(data);

      //创建二进制对象写入转换好的字节流
      let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {
        type: "application/octet-stream"
      });
      // 保存文件
      FileSaver.saveAs(tmpDown, "example.xlsx");
    },
    // 字符串转字符流
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefined") {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        let buf = new Array(s.length);
        for (let j = 0; j != s.length; ++j) buf[j] = s.charCodeAt(j) & 0xff;
        return buf;
      }
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped></style>
